(() => {
  const intro = document.querySelector('[data-kt-intro]');
  if (!intro) return;

  const body = document.body;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealMs = Number(intro.dataset.revealMs || 5000);
  const readyMs = Number(intro.dataset.readyMs || 6500);
  let revealTimer;
  let readyTimer;

  const finishImmediately = () => {
    body.classList.add('kt-intro-reveal');
    body.classList.remove('kt-intro-pending');
    body.style.removeProperty('overflow');
    intro.remove();
  };

  if (reduceMotion) {
    finishImmediately();
    return;
  }

  revealTimer = window.setTimeout(() => {
    body.classList.add('kt-intro-reveal');
  }, revealMs);

  readyTimer = window.setTimeout(() => {
    body.classList.remove('kt-intro-pending');
    body.classList.remove('kt-intro-reveal');
    body.style.removeProperty('overflow');
    intro.remove();
  }, readyMs);

  window.addEventListener('pagehide', () => {
    window.clearTimeout(revealTimer);
    window.clearTimeout(readyTimer);
  }, { once: true });
})();
